export default __webpack_public_path__ + "static/media/miguel-lopes-31.a9b2fd89.jpg";